import React, {FC} from 'react'

import cn from 'classnames/bind'

import PortableBlocks from 'components/blocks/PortableBlocks'
import ToggleableTextGroup from 'components/elements/ToggleableTextGroup/ToggleableTextGroup'
import {BlockContent} from 'src/types/__sanitySchema__'

import s from './LandingsAccordion.module.scss'
const cx = cn.bind(s)

interface ILandingsAccordionProps {
	className?: string
	items: {title?: string | undefined; description?: string | BlockContent | undefined}[] | undefined
}

/** Description of component */
const LandingsAccordion: FC<ILandingsAccordionProps> = ({className, items}) => {
	return (
		<div className={cx('wrapper', className)}>
			{items?.map((item) => {
				return (
					<div key={item.title} className={cx('item')}>
						<ToggleableTextGroup
							headerClassName={cx('header', 'text-uppercase')}
							bodyClassName={cx('body')}
							header={item.title || ''}>
							{Array.isArray(item.description) ? (
								//  eslint-disable-next-line @typescript-eslint/no-non-null-assertion
								<PortableBlocks blockContent={item.description!} />
							) : (
								<span className={s.description}>{item.description}</span>
							)}
						</ToggleableTextGroup>
					</div>
				)
			})}
		</div>
	)
}

LandingsAccordion.displayName = 'LandingsAccordion'

export default LandingsAccordion
